import React, { useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { computeLevelFromCompletedGames, getDailyChallenge } from "../modules/play/engine";
import { playGamesMock } from "../modules/play/mock";
import { DailyChallengeCard } from "../modules/play/components";

// Hub principal Play : structure avec niveau mock et défi du jour.
export default function PlayHub() {
  const navigate = useNavigate();
  // progression mock (0 jeux complétés pour l'instant)
  const mockCompleted = 0;
  const levelInfo = computeLevelFromCompletedGames(mockCompleted);
  const challenge = useMemo(() => getDailyChallenge(), []);
  const challengeGame = challenge ? playGamesMock.find((g) => g.id === challenge.gameId) : undefined;

  const sections = [
    { title: "Mini-jeux", to: "/play/minijeux", desc: "Exercices rapides pour entraîner ton attention." },
    { title: "Illusions", to: "/play/illusions", desc: "Expériences visuelles pour questionner ta perception." },
    { title: "Défis", to: "/play/defis", desc: "Défi du jour et classement (à venir)." },
    { title: "Entraînements", to: "/play/entrainements", desc: "Parcours courts pour muscler l'esprit critique." },
  ];

  return (
    <div className="max-w-6xl mx-auto space-y-8">
      <header className="space-y-2">
        <h1 className="text-3xl font-semibold text-slate-900 dark:text-white">MixMind Play</h1>
        <p className="text-sm md:text-base text-slate-700 dark:text-slate-300">
          Le terrain de jeu cognitif : mini-jeux, illusions, défis et entraînements pour tester ta perception et ta
          concentration.
        </p>
        <div className="mm-surface p-4 flex items-center justify-between flex-wrap gap-3">
          <div>
            <p className="text-xs text-slate-500 dark:text-slate-400">Niveau actuel (mock)</p>
            <p className="text-lg font-semibold">
              {levelInfo.label} · {levelInfo.level}
            </p>
          </div>
          <p className="text-xs text-slate-500 dark:text-slate-400">
            Jeux complétés (mock) : {mockCompleted} / prochain niveau à {levelInfo.requiredGamesCompleted}
          </p>
        </div>
      </header>

      {challenge && (
        <section className="space-y-3">
          <h2 className="text-xl font-semibold">Défi du jour</h2>
          <DailyChallengeCard
            challenge={challenge}
            game={challengeGame}
            onPlay={() => navigate("/play/defis")}
          />
        </section>
      )}

      <section className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        {sections.map((s) => (
          <Link
            key={s.to}
            to={s.to}
            className="mm-surface p-4 hover:-translate-y-0.5 hover:shadow-md transition-transform"
          >
            <h2 className="text-lg font-semibold mb-1">{s.title}</h2>
            <p className="text-sm text-slate-700 dark:text-slate-300">{s.desc}</p>
          </Link>
        ))}
      </section>
    </div>
  );
}
